import RaceShareInfo from './RaceShareInfo';

export default RaceShareInfo;
